// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__TnKDf","note":"pending-approval-badge_note__nMYz7","icon":"pending-approval-badge_icon__d8dgR"};